import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const BEFORE_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/06ae7740-6c19-4c0f-839c-f92d7d3e8907.jpg';
const AFTER_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/141adcd5-9264-4685-b8b4-2122e5d7a1e8.jpg';
const testimonios = [{
  nombre: 'Lucía Fernández',
  ciudad: 'Córdoba',
  texto: 'Nunca había tocado un globo con intención y en un mes armé el arco del cumple de mi sobrino. ¡Me encargaron dos eventos más!',
  inicial: 'L'
}, {
  nombre: 'Marina Sosa',
  ciudad: 'Rosario',
  texto: 'Lo mejor fue el módulo de precios. Dejé de regalar mi trabajo y ya tengo clientas fijas todos los meses.',
  inicial: 'M'
}, {
  nombre: 'Sofía Herrera',
  ciudad: 'Mendoza',
  texto: 'Aprendí a mi ritmo, entre las siestas de mi bebé. Hoy la decoración es mi ingreso extra desde casa.',
  inicial: 'S'
}];
export function Testimonios() {
  return <section className="w-full bg-white py-24" data-id="element-145" data-mp="1nbi0t2qyogo4">
      <div className="mx-auto max-w-6xl px-6" data-id="element-146" data-mp="1naq5lt1a0kyd">
        <Reveal data-id="element-147" data-mp="1s4b5xrqcdr0q">
          <h2 className="font-display text-center text-3xl font-semibold text-[#2f2a33] sm:text-4xl" data-id="element-148" data-mp="1s4ucydegeuzz">
            Esto dicen quienes ya lo hicieron
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-149" data-mp="1jc0uk73pnfhw">
          {testimonios.map((t, i) => <Reveal key={i} delay={i * 0.08} data-id="element-150" data-mp="271leas7ougs8" data-mpi={i}>
              <figure className="flex h-full flex-col rounded-2xl border border-[#a78bdb]/20 bg-[#faf7fe] p-7" data-id="element-151" data-mp="26ypgr4zr5u4b">
                <div className="flex text-[#f4d160]" data-id="element-152" data-mp="1x2cn2747jg9k">
                  {Array.from({
                length: 5
              }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-current" data-id="element-153" data-mp="220xouaz3y804" data-mpi={s} />)}
                </div>
                <blockquote className="mt-4 flex-1 text-[#2f2a33]/80" data-id="element-154" data-mp="lmxpp2836mdx">
                  “{t.texto}”
                </blockquote>
                <figcaption className="mt-6 flex items-center gap-3" data-id="element-155" data-mp="qnv5x99jd6cs">
                  <span className="grid h-11 w-11 place-items-center rounded-full bg-[#ec4899] font-semibold text-white" data-id="element-156" data-mp="6j4fl31eovxi">
                    {t.inicial}
                  </span>
                  <div data-id="element-157" data-mp="3twqag6pjspr6">
                    <p className="font-semibold text-[#2f2a33]" data-id="element-158" data-mp="3tw87kr8drdaa">{t.nombre}</p>
                    <p className="text-sm text-[#2f2a33]/55" data-id="element-159" data-mp="3oyotbrbon0ic">{t.ciudad}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>

        <Reveal delay={0.1} data-id="element-160" data-mp="3ezhgd58v17vr">
          <div className="mt-12 overflow-hidden rounded-3xl border border-[#a78bdb]/20 bg-[#faf7fe]" data-id="element-161" data-mp="3ez7p7ec2wuoh">
            <div className="grid sm:grid-cols-2" data-id="element-162" data-mp="3az6zgxjj4x24">
              {[{
              img: BEFORE_IMG,
              label: 'Antes',
              alt: 'Primera decoración de una alumna, sencilla'
            }, {
              img: AFTER_IMG,
              label: 'Después',
              alt: 'Decoración profesional de una alumna tras el curso'
            }].map(b => <div key={b.label} className="relative" data-id="element-163" data-mp="148pm5k2govgs">
                  <img src={b.img} alt={b.alt} className="h-72 w-full object-cover" data-id="element-164" data-mp="1bs8pfbz4vlgt" />
                  <span className="absolute left-4 top-4 rounded-full bg-[#2f2a33]/85 px-4 py-1 text-sm font-semibold text-white" data-id="element-165" data-mp="1gqa47kpj0ymh">
                    {b.label}
                  </span>
                </div>)}
            </div>
            <p className="px-6 py-5 text-center text-[#2f2a33]/70" data-id="element-166" data-mp="1qftql0cg7am3">
              El antes y después de una de nuestras alumnas — de su primer
              intento a su primer trabajo pago.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}